export enum ElementTypes {
  SCREEN = 'Screen',
  ROUND_TABLE = 'RoundTable',
  SQUARE_TABLE = 'SquareTable',
  ENTRANCE_EXIT = 'EntranceExit',
  STAIRCASE = 'Staircase',
}
